import { Link, TrackingData } from '@ecm/router';

export class MegapushModel {
    public cid?: string;
    public img159?: string;
    public img160?: string;
    public imgUrl?: string;
    public isSosh?: boolean;
    public text?: string;
    public text2?: string;
    public title?: string;
    public trackingData?: TrackingData;
    public urlLabel?: string;
    public urlWeb?: Link;

    public constructor(init?: Partial<MegapushModel>) {
        Object.assign(this, init);
    }
}
